import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { routesColumns } from '../../../assets/const/Constant';
import ArchiveIcon from '../../../assets/images/icons/archive.svg';
import DuplicateIcon from '../../../assets/images/icons/duplicate.svg';
import EditIcon from '../../../assets/images/icons/edit.svg';
import ReportIcon from '../../../assets/images/icons/report.svg';
import SampleIcon from '../../../assets/images/icons/sample.svg';
import { ApiData } from '../../../data/apiData';
import BootstrapDateRangePicker from '../../date/BootstrapDateRangePicker';
import ColumnsFilter from '../../filter/ColumnsFilter';
import Filter from '../../filter/Filter';
import getRequest, { postRequest, useApi } from '../../../assets/helper/ApiHandler';
import handleErrors from '../../../assets/apiEroor/ErrorHandler';
import PopupContent from '../PopupContent';
import ModalClose from '@mui/icons-material/CloseRounded';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import moment from 'moment/moment';
import { event } from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import PaginatorTemplate from '../../PanginatorTemplate';
import { Toast } from 'primereact/toast';
import { setFilters } from '../../../redux/reducer/filterslice';
import { cloneDeep } from 'lodash';
import { ActionBttonColumn } from '../../ActionButtonColumn';
import { ROUTES } from '../../../assets/const/reportTypeConst';
import { statusBodyTemplate } from '../../template/StatusBody';
import { demandRequestsBodyTemplate, erpmBodyTemplate, fillRateBodyTemplate, impressionsBodyTemplate, revenueBodyTemplate, rpmrBodyTemplate } from '../../template/PrefixAndSuffixBody';

export default function RoutesPage() {
    const [dates, setDates] = useState({
        startDate: useSelector(state => state.dateRange.startDate),
        endDate: useSelector(state => state.dateRange.endDate)
    });
    const toast = useRef(null);
    const filterControlOverlay = useRef(null);
    const [routesData, setRoutesData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const dispatch = useDispatch();
    const filters = useSelector(state => state.filters.currentFilters);
    const defaultSelectedColumns = [routesColumns[0], routesColumns[1], routesColumns[2], routesColumns[3], routesColumns[4], routesColumns[5], routesColumns[6], routesColumns[7]];
    const [selectedColumnsVisibility, setColumnsVisibility] = useState(defaultSelectedColumns);
    const [tableColumns, setTableColumns] = useState(defaultSelectedColumns);
    const navigate = useNavigate();
    const [state, setState] = useState({ selectedColumnsVisibility, right: false, });
    const location = useLocation();
    const RoutesFromReports = location.state ? location.state.routes : null;
    const [demandAlignmentData, setDemandAlignmentData] = useState([]);
    const [supplyAlignmentData, setSupplyAlignmentData] = useState([]);
    const [clickedRouteName, setClickedRouteName] = useState(null);
    const [hoveredRoute, setHoveredRoute] = useState(null);
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const totalRecords = useSelector(state => state.totalRecords.count);
    const { getUseRequest } = useApi();
    const [isLoading, setIsloading] = useState([]);

    useEffect(() => {
        fetchData();
    }, [rows, currentPage]);

    useEffect(() => {
        if (location.state && location.state.routes) {
            filterGlobalValue(RoutesFromReports.name)
        }
    }, [location.state])


    const filterGlobalValue = (value) => {
        let _filters = cloneDeep(filters);
        _filters.global.value = value;
        dispatch(setFilters(_filters));
        setGlobalFilterValue(value);
    }

    const onGlobalFilterChange = (e) => {
        filterGlobalValue(e.target.value);
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const handleRowHover = (event) => {
        const rowData = event.data;
        setHoveredRoute(rowData ? rowData.name : null);
    };

    const fetchData = async () => {
        setIsloading(true);
        try {
            const url = `/report/routes/main?startDate=${dates.startDate}&endDate=${dates.endDate}&page=${currentPage}&size=${rows}&sort=id,desc`;
            const reportingData = await getUseRequest(url, null, navigate);
            const truncatedRoutesData = reportingData.map(route => {
                const truncatedName = route.name.length > 70 ? route.name.slice(0, 70) + '...' : route.name;
                return { ...route, name: truncatedName };
            });
            setRoutesData(truncatedRoutesData);
        }

        catch (error) {
            console.error("Error fetching supply data:", error);
            const errorMessage = handleErrors(error.response?.status || 'An unknown error occurred', navigate);
        } finally {
            setIsloading(false);
        }
    };

    const replaceNullWithZero = (rowData, field) => {
        return rowData[field] === null ? 0 : rowData[field];
    };


    const handleOnRowsChange = (newRows) => {
        setRows(newRows.value);
        setCurrentPage(0);
    };

    const handleOnPageChange = (page) => {
        setCurrentPage(page);
    }

    const applyFiltersOnColumns = (columns) => {
        setTableColumns(columns);
    };

    const handleSelectedDate = (dates) => {
        setDates(dates);
    }

    const renderHeader = () => {
        return (
            <>
                <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                    </span>
                    {/* <span className="p-input-icon-left">
                        <i className="pi pi-calendar" />
                        <BootstrapDateRangePicker
                            dates={dates}
                            selectedDate={handleSelectedDate} />
                    </span> */}
                    <span className="p-input-icon-left">
                        <Filter
                            columnsList={routesColumns}
                        />
                    </span>
                    <span className="p-input-icon-left">
                        <ColumnsFilter
                            columnsList={routesColumns}
                            tableColumns={tableColumns}
                            index={8}
                            applyColumns={applyFiltersOnColumns}
                        />
                    </span>
                </div>
            </>
        );
    };


    const [statuses] = useState(['Active', 'Stopped']);
    const getSeverity = (status) => {
        switch (status) {
            case 'Active':
                return 'success';
            case 'Stopped':
                return 'danger';
        }
    };


    const testRow = (row) => {
        if (row && row.supplies && row.demand) {
            const supplyData = row.supplies.map(supply => ({ name: supply.name }));
            const demandData = [{ name: row.demand.name }];
            setSupplyAlignmentData(supplyData);
            setDemandAlignmentData(demandData);
        } else {
            console.error("Unexpected response structure in the row object:", row);
        }
    };


    const routes = (routesData) => {
        const handleRowClick = (anchor) => {
            testRow(routesData);
            console.log(routesData.name)
            toggleDrawer(anchor, true)(event);
            setClickedRouteName(routesData.name);
        };
        return (
            <div>
                {['right'].map((anchor) => (
                    <div className="supplyPartner flex justify-content-left" key={anchor} onClick={() => handleRowClick(anchor)}
                        title={routesData.name}>
                        {routesData.name}
                    </div>
                ))}
            </div>

        );
    };

    const duplicateRoutes = async (data) => {
        let list = [...routesData];
        let dpData = { ...data };
        try {
            dpData.name = `Duplicate_${dpData.name}`;
            delete dpData.id;
            const response = await postRequest('/supply-to-demand-filters', dpData, navigate);
            let res = [response.data, ...list];
            setRoutesData(res);
        } catch (error) {
            console.error('Error duplicating demand partner:', error);
        }
    };

    const handleArchiveChange = (id, isArchived) => {
        setRoutesData(prevData =>
            prevData.map(row =>
                row.id === id ? { ...row, isArchived: isArchived } : row
            )
        );
    }

    const actionBtn = (rowData) => {
        return (
            <ActionBttonColumn
                rowData={rowData}
                type={ROUTES}
                handleDuplicateRow={duplicateRoutes}
                onArchiveChange={handleArchiveChange}

            />
        );
    };

    return (
        <div className="card">
            <Toast ref={toast} position="bottom-right"></Toast>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2>Routes</h2>
                </Typography>
                <Link to='/routes/create'><Button type="button" icon="pi pi-plus" className="button-style-1" label="Add Route" size="small"></Button></Link>

                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <DataTable
                value={routesData}
                // scrollable 
                // scrollHeight="400px"
                filters={filters}
                loading={isLoading}
                header={renderHeader()}
                emptyMessage="No customers found."
                selectionMode={rowClick ? null : 'checkbox'}
                selection={selectedProducts}
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                paginator rows={rows}
                paginatorTemplate={
                    PaginatorTemplate({
                        currentPage,
                        totalRecords,
                        rows,
                        handleOnRowsChange,
                        handleOnPageChange,
                    })}
                tableStyle={{ minWidth: '50rem' }}
                resizableColumns
            >
                {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                {tableColumns.length > 0 ? (
                    tableColumns.map(column => (
                        <Column
                            key={column.key}
                            field={column.field}
                            header={column.name}
                            // headerStyle={{ textAlign: 'left' }}
                            // alignHeader={'left'}
                            headerStyle={column.key == 2 || column.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' } && column.key == 3 ? { textAlign: 'center' } : { textAlign: 'right' }}
                            alignHeader={column.key == 2 || column.key == 1 ? "left" : "right" && column.key == 3 ? "center" : "right"} 
                            bodyStyle={column.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' }}
                            // body={column.key === "2" ? statusBodyTemplate : (column.key === "1" ? routes : null)}

                            body={(rowData, column) => {
                                switch (column.field) {
                                    case "name":
                                        return routes(rowData);
                                    case "isEnabled":
                                        return statusBodyTemplate(rowData);
                                    case "erpm":
                                        return erpmBodyTemplate(rowData);
                                    case "rpmr":
                                        return rpmrBodyTemplate(rowData);
                                    case "fillRate":
                                        return fillRateBodyTemplate(rowData);
                                    case "impressions":
                                        return impressionsBodyTemplate(rowData);
                                    case "demandRequests":
                                        return demandRequestsBodyTemplate(rowData);
                                    case "revenue":
                                        return revenueBodyTemplate(rowData);
                                    default:
                                        return replaceNullWithZero(rowData, column.field);
                                }
                            }} 
                        />
                    ))
                ) : (
                    <>
                    </>

                )}
                <Column field="action" body={actionBtn} header="Action" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>
            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    <Box className='drawerHeader'>
                        <DialogTitle title={clickedRouteName}>
                            {clickedRouteName?.length > 47 ? clickedRouteName.slice(0, 47) + '...' : clickedRouteName}
                        </DialogTitle> {/* Tooltip with full name */}
                        <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                    </Box>
                    <PopupContent
                        PerformanceLabel2="Demand Alignment"
                        PerformanceLabel1="Supply Alignment"
                        demandAlignment={demandAlignmentData}
                        supplyAlignment={supplyAlignmentData} />
                </Drawer>
            ))}
        </div>
    )
}
